/* tslint:disable */
/* eslint-disable */
/**
 * HCL Commerce Services - Account and Contract
 * These services provide APIs to manage accounts and contracts.  a contract is an agreement that represents the terms and conditions that apply to a transaction. An account is a relationship between the merchant and the financial institution that processes transactions for that merchant.
 *
 * The version of the OpenAPI document: 9.1.6
 * 
 * (C) Copyright HCL Technologies Limited 2021
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../../../../../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../../../../../base';
// @ts-ignore
import { ScanAttachmentsRequest } from '../../../../../com/hcl/commerce/typescript/axios';
// @ts-ignore
import { ScanAttachmentsResponse } from '../../../../../com/hcl/commerce/typescript/axios';
/**
 * ScanAttachmentsApi - axios parameter creator
 * @export
 */
export const ScanAttachmentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Scan uploaded reclaim attachment files for validation and virus check.
         * @summary Scan reclaim attachments
         * @param {string} storeId The store identifier.
         * @param {ScanAttachmentsRequest} scanAttachmentsRequest The request object for scanning attachments.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scanAttachments: async (storeId: string, scanAttachmentsRequest: ScanAttachmentsRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('scanAttachments', 'storeId', storeId)
            // verify required parameter 'scanAttachmentsRequest' is not null or undefined
            assertParamExists('scanAttachments', 'scanAttachmentsRequest', scanAttachmentsRequest)
            const localVarPath = `/store/{storeId}/reclaim/scanAttachments`
                .replace(`{${"storeId"}}`, String(storeId));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(scanAttachmentsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ScanAttachmentsApi - functional programming interface
 * @export
 */
export const ScanAttachmentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ScanAttachmentsApiAxiosParamCreator(configuration)
    return {
        /**
         * Scan uploaded reclaim attachment files for validation and virus check.
         * @summary Scan reclaim attachments
         * @param {string} storeId The store identifier.
         * @param {ScanAttachmentsRequest} scanAttachmentsRequest The request object for scanning attachments.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scanAttachments(storeId: string, scanAttachmentsRequest: ScanAttachmentsRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScanAttachmentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scanAttachments(storeId, scanAttachmentsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ScanAttachmentsApi - factory interface
 * @export
 */
export const ScanAttachmentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ScanAttachmentsApiFp(configuration)
    return {
        /**
         * Scan uploaded reclaim attachment files for validation and virus check.
         * @summary Scan reclaim attachments
         * @param {string} storeId The store identifier.
         * @param {ScanAttachmentsRequest} scanAttachmentsRequest The request object for scanning attachments.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scanAttachments(storeId: string, scanAttachmentsRequest: ScanAttachmentsRequest, options?: any): AxiosPromise<ScanAttachmentsResponse> {
            return localVarFp.scanAttachments(storeId, scanAttachmentsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ScanAttachmentsApi - object-oriented interface
 * @export
 * @class ScanAttachmentsApi
 * @extends {BaseAPI}
 */
export class ScanAttachmentsApi extends BaseAPI {
    /**
     * Scan uploaded reclaim attachment files for validation and virus check.
     * @summary Scan reclaim attachments
     * @param {string} storeId The store identifier.
     * @param {ScanAttachmentsRequest} scanAttachmentsRequest The request object for scanning attachments.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScanAttachmentsApi
     */
    public scanAttachments(storeId: string, scanAttachmentsRequest: ScanAttachmentsRequest, options?: any) {
        return ScanAttachmentsApiFp(this.configuration).scanAttachments(storeId, scanAttachmentsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
